export const getFormControlIds = (id: string) => {
  return {
    label: `label-${id}`,
    input: `input-${id}`,
    helperText: `helper-text-${id}`
  };
};
